var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-misused-promises */
import React from 'react';
import { Form } from 'react-final-form';
import { Button, FFDropdown, FFMultiSelectDropdown, FFTextInput } from '@leapfinance/geebee-component-library';
import FilterListRoundedIcon from '@mui/icons-material/FilterListRounded';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import omit from 'lodash/omit';
import { SOPTypeOptions } from './utils';
var SOPTrackingFilters = function (_a) {
    var sopRequestTypeProps = _a.sopRequestTypeProps, handleFilterApply = _a.handleFilterApply, _b = _a.source, source = _b === void 0 ? 'CSP' : _b, handleOpenMoreFilters = _a.handleOpenMoreFilters, initialValues = _a.initialValues, moreFiltersApplied = _a.moreFiltersApplied, sopStatusOptions = _a.sopStatusOptions;
    return (React.createElement(Form, { onSubmit: function (values) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                handleFilterApply(values);
                return [2 /*return*/];
            });
        }); }, initialValues: initialValues, render: function (_a) {
            var form = _a.form, handleSubmit = _a.handleSubmit;
            return (React.createElement("div", { className: "lfc-flex lfc-justify-between lfc-items-end" },
                React.createElement("div", { className: "lfc-flex lfc-gap-3" },
                    source === 'CSP' ? (React.createElement(FFTextInput, { fieldProps: {
                            name: 'requestId'
                        }, componentProps: {
                            label: 'Request ID',
                            placeholder: 'Enter Request ID',
                            size: 'small',
                            className: 'lfc-bg-white',
                            type: 'number',
                            InputProps: {
                                startAdornment: React.createElement(SearchRoundedIcon, null)
                            },
                            onKeyDown: function (event) {
                                if (event.code === 'Enter') {
                                    handleSubmit();
                                }
                            }
                        } })) : null,
                    React.createElement(FFTextInput, { fieldProps: {
                            name: 'studentName'
                        }, componentProps: {
                            label: 'Student Name',
                            placeholder: 'Enter Student Name',
                            size: 'small',
                            className: 'lfc-bg-white',
                            InputProps: {
                                startAdornment: React.createElement(SearchRoundedIcon, null)
                            },
                            onKeyDown: function (event) {
                                if (event.code === 'Enter') {
                                    handleSubmit();
                                }
                            }
                        } }),
                    source === 'SPEEDUP' ? (React.createElement("div", null,
                        React.createElement(FFMultiSelectDropdown, { fieldProps: { name: 'sopStatus' }, componentProps: {
                                size: 'small',
                                textInputProps: {
                                    label: 'Request Status',
                                    placeholder: 'Select Status',
                                    className: 'lfc-bg-white lfc-w-[200px]'
                                },
                                options: sopStatusOptions !== null && sopStatusOptions !== void 0 ? sopStatusOptions : []
                            } }))) : (React.createElement(FFTextInput, { fieldProps: {
                            name: 'universityName'
                        }, componentProps: {
                            label: 'University Name',
                            placeholder: 'Enter University Name',
                            size: 'small',
                            className: 'lfc-bg-white',
                            InputProps: {
                                startAdornment: React.createElement(SearchRoundedIcon, null)
                            },
                            onKeyDown: function (event) {
                                if (event.code === 'Enter') {
                                    handleSubmit();
                                }
                            }
                        } })),
                    React.createElement(FFDropdown, { fieldProps: sopRequestTypeProps === null || sopRequestTypeProps === void 0 ? void 0 : sopRequestTypeProps.fieldProps, componentProps: __assign(__assign({ size: 'small', textInputProps: {
                                label: 'SOP Request Type',
                                placeholder: 'Select Request Type',
                                size: 'small',
                                className: 'lfc-bg-white'
                            } }, omit(sopRequestTypeProps === null || sopRequestTypeProps === void 0 ? void 0 : sopRequestTypeProps.componentProps, ['options', 'onKeyDown'])), { options: SOPTypeOptions, onKeyDown: function (event) {
                                if (event.code === 'Enter') {
                                    handleSubmit();
                                }
                            } }) }),
                    source === 'SPEEDUP' ? (React.createElement("div", { className: "lfc-flex lfc-items-end" },
                        React.createElement(Button, { className: "lfc-flex lfc-max-w-fit lfc-whitespace-nowrap", variant: "secondary", size: "medium", startIcon: React.createElement(FilterListRoundedIcon, { className: "lfc-w-7 lfc-h-7" }), onClick: handleOpenMoreFilters },
                            "More Filters ",
                            !moreFiltersApplied ? '' : "(".concat(moreFiltersApplied, ")")))) : null),
                React.createElement("div", { className: "lfc-flex lfc-gap-3" },
                    React.createElement(Button, { size: "small", variant: "secondary", onClick: function () {
                            form.reset();
                            handleFilterApply({});
                        } }, "Clear"),
                    React.createElement(Button, { size: "small", onClick: handleSubmit }, "Apply Filter"))));
        } }));
};
export default SOPTrackingFilters;
//# sourceMappingURL=SOPDashboardFilters.js.map